import { api } from "./api";

// F-GUIDE-032 セッション管理・端末強制失効（tst-jjcr）。apps/api/src/guide-sessions.ts と対。
// guide-web はサインイン成功直後の自己登録のみ使う（一覧・個別 revoke は guide-app の G-14 が担当）。

/** サインイン成功直後に呼ぶ自己登録。id を AuthContext が localStorage へ保存し、以後 x-session-id
 *  ヘッダとして自動付与される（api.ts）。失敗しても致命ではない（全端末一括失効の判定は残る）。 */
export function registerSession(label?: string): Promise<{ id: string; createdAt: string }> {
  return api<{ id: string; createdAt: string }>("/guide-sessions", {
    method: "POST",
    body: { deviceLabel: label },
  });
}

/** User-Agent から簡易な端末表記を作る（例: "Chrome on macOS"）。厳密なパースはしない自己申告用途。 */
export function deviceLabel(): string {
  const ua = navigator.userAgent;
  const browser = /Edg\//.test(ua)
    ? "Edge"
    : /Chrome\//.test(ua)
      ? "Chrome"
      : /CriOS/.test(ua)
        ? "Chrome"
        : /Firefox\//.test(ua)
          ? "Firefox"
          : /Safari\//.test(ua)
            ? "Safari"
            : "Browser";
  const os = /iPhone|iPad|iOS/.test(ua)
    ? "iOS"
    : /Android/.test(ua)
      ? "Android"
      : /Mac OS X/.test(ua)
        ? "macOS"
        : /Windows/.test(ua)
          ? "Windows"
          : "device";
  return `${browser} on ${os}`;
}
